import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { map, prop } from 'ramda'
import { generatePath } from 'react-router-dom'

import { NewButton } from '~/components/Buttons'
import PageTitle from '~/components/PageTitle'
import Container, { Content, Header } from '~/components/Container'
import { Table, TableHeader } from '~/components/Table'
import * as ROUTES from '~/constants/routes'
import TableDateFormat from '~/components/TableDateFormat/TableDateFormat'
import TableLink from '~/components/Link'
import LinkButton from '~/components/Buttons/LinkButton'
import MoreListButton from '~/components/Buttons/MoreListButton'

export const ROLE_COLUMNS = [
  {
    width: 200,
    headerName: 'City',
    field: 'city',
    renderCell: ({ value, row }) => (
      <TableLink to={row.link}>
        {value}
      </TableLink>
    )
  },
  {
    width: 200,
    headerName: 'Carrier',
    field: 'carrier'
  },
  {
    width: 150,
    headerName: 'Created date',
    field: 'createdAt',
    renderCell: ({ value }) => (
      <TableDateFormat date={value} withTime={true} />
    )
  },
  {
    width: 150,
    headerName: 'Updated date',
    field: 'updatedAt',
    renderCell: ({ value }) => (
      <TableDateFormat date={value} withTime={true} />
    )
  },
]

const getRowsFromResults = map(item => {
  const id = prop('id', item)
  const city = prop('city', item)
  const carrier = prop('carrier', item)
  const createdAt = prop('createdAt', item)
  const updatedAt = prop('updatedAt', item)
  const link = generatePath(ROUTES.CITY_MAPPING_UPDATE_PATH, { id })

  return {
    id,
    city,
    carrier: prop('name', carrier),
    createdAt,
    updatedAt,
    link
  }
})

function CityMappingTable ({ list, ordering, onListRefetch }) {
  const [tableRef, setTableRef] = useState(null)
  const isLoading = prop('isLoading', list)
  const results = prop('results', list)
  const count = prop('count', list)
  const columns = prop('filteredColumns', ordering)

  return (
    <Container>
      <Header>
        <PageTitle
          pageTitle="City Mapping"
          parentTitle="Settings"
          rightButton={(
            <>
              <NewButton path={ROUTES.CITY_MAPPING_CREATE_PATH} />
              <LinkButton href={ROUTES.CITY_MAPPING_IMPORT_PATH}>
                Import
              </LinkButton>
            </>
          )}
        />
      </Header>

      <Content>
        <TableHeader>
          <MoreListButton tableRef={tableRef} />
        </TableHeader>
        <Table
          isLoading={isLoading}
          columns={columns}
          getRowsFromResults={getRowsFromResults}
          results={results}
          count={count}
          pinnedColumns={['name']}
          checkboxSelection={true}
          ordering={ordering}
          onRefetch={onListRefetch}
          setTableRef={setTableRef}
        />
      </Content>
    </Container>
  )
}

CityMappingTable.propTypes = {
  list: PropTypes.object.isRequired,
  ordering: PropTypes.object.isRequired,
  onListRefetch: PropTypes.func.isRequired,
}

export default CityMappingTable
